import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AppStateService } from 'app/services/app-state.service';

@Component({
  selector: 'app-page-wrapper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-wrapper.component.html',
  styleUrl: './page-wrapper.component.scss'
})
export class PageWrapperComponent {
  @Input() scrollable: boolean;

  constructor(public appState: AppStateService) {}
}
